module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/v8P51w/tc-custom/9781440506932.jpg?1721442173604",
      "alt": "This image is the cover for the book 1,001 Facts that Will Scare the S#*t Out of You"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("1,001 Facts that Will Scare the S#*t Out of You\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Fact:")]), _vm._v(" Chocolate contains the alkaloid theobromine, which in high doses can be toxic to humans, and in even small amounts can kill dogs, parrots, horses, and cats."), _c('br'), _c('i', [_vm._v("This means that despite its name, the Kit-Kat candy bar is not a recommended snack for your kitty-cat. I wonder how many cats have died because of this confusion.")]), _c('br'), _c('br'), _c('b', [_vm._v("Fact:")]), _vm._v(" The most germ-laden place on your toilet isn't the seat or even the bowl--it's the handle."), _c('br'), _c('i', [_vm._v("The solution: Don't flush. Let the next guy worry about it.")]), _c('br'), _c('br'), _vm._v("There are \"just the facts\"--and then there are just the facts that will frighten the bejeezus out of you. And thanks to this little gem of a bathroom book, you'll never look at the world the same way again, without, er, dry heaving a little bit."), _c('br'), _c('br'), _vm._v("From the sneaky fish that can swim up our genitals to the "), _c('i', [_vm._v("E. coli")]), _vm._v(" bacteria lurking in the very water we drink, disturbing phenomena are everywhere we turn. Educational, entertaining, and undeniably horrifying, this book isn't guaranteed to help you, um, go to the bathroom, but it's certain to make your time there more...informed.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cary McNeal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An Adams Media author.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0